var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-left"},[_c('div',{staticClass:"titleBox"},[_vm._v("推荐商品")]),_vm._v(" "),_vm._l((_vm.goodsList),function(item){return _c('goods-item',{key:item.goods_id,attrs:{"goods-info":item}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74df63cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mall/goodsClass/private/boxLeft.vue
// module id = null
// module chunks = 